import { getPageAllowedRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { SitemapField } from "./SitemapField";
import { sitemapPageConfig } from "./sitemapPageConfig";
import {
  adaptSitemap,
  afterSitemapSave,
  sitemapValidators,
  toSitemapPayload,
} from "./sitemapRecord";

export const sitemapRecordDefinition: RecordDefinition = {
  path: "/sitemap",
  entityName: "sitemap",
  listRoute: "/settings",
  backTitle: "Back to settings",
  allowedRoles: getPageAllowedRoles("sitemap"),
  // The config only declares the field the pending-edit check validates.
  config: sitemapPageConfig,
  body: SitemapField,
  // One sitemap per organisation, laid out here and nowhere else.
  authorable: false,
  readMethod: "GetInitialState",
  recordAdapter: adaptSitemap,
  toSavePayload: toSitemapPayload,
  afterSave: afterSitemapSave,
  identity: {
    titleFields: [],
    fallbackTitle: "Sitemap",
    newRecordTitle: "Sitemap",
  },
  fieldComponents: {
    sitemapDesigner: SitemapField,
  },
  fieldValidators: sitemapValidators,
};
